var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTowers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    viewBox: "0 0 74 74",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54 72H37a1 1 0 0 1-1-1V3a1 1 0 0 1 1.64-.768l12 10a1 1 0 0 1 .356.682l5 58A1 1 0 0 1 54 72zm-16-2h14.91l-4.87-56.5L38 5.135zM59.159 44.79a1 1 0 0 1-.995-.914l-.25-2.9a1 1 0 0 1 1.992-.172l.25 2.9a1 1 0 0 1-.91 1.082.844.844 0 0 1-.087.004z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 72H54a1 1 0 0 1 0-2h6.41l-.786-9.155a1 1 0 0 1 .911-1.081.987.987 0 0 1 1.081.91l.88 10.241A1 1 0 0 1 61.5 72zM60.019 54.76a1 1 0 0 1-.995-.913l-.26-2.97a1 1 0 1 1 1.992-.174l.26 2.969a1 1 0 0 1-.909 1.084.864.864 0 0 1-.088.004zM58.3 34.89a1 1 0 0 1-1-.914l-.584-6.825-7.76-6.473a1 1 0 0 1 1.282-1.536l8.08 6.74a1 1 0 0 1 .356.682l.619 7.241a1 1 0 0 1-.911 1.082zM37 72H20a1 1 0 0 1-1-1.086l5-58a1 1 0 0 1 .356-.682l12-10A1 1 0 0 1 38 3v68a1 1 0 0 1-1 1zm-15.91-2H36V5.135L25.96 13.5z",
    fill: "#FFFFFF",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 72h-9.5a1 1 0 0 1-.988-1.154l5-32a1 1 0 0 1 .388-.646l7.76-5.82a1 1 0 1 1 1.2 1.6l-7.435 5.576L11.668 70H20a1 1 0 0 1 0 2z",
    fill: "#FFFFFF",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.391 67.52a1 1 0 0 1-.539-1.843l16.61-10.6a1 1 0 0 1 1.076 1.686l-16.61 10.6a1 1 0 0 1-.537.157zM21.371 56.16a1 1 0 0 1-.538-1.843l15.629-9.97a1 1 0 0 1 1.076 1.686L21.908 56a1 1 0 0 1-.537.16zM22.341 44.81a1 1 0 0 1-.539-1.843l14.66-9.35a1 1 0 0 1 1.076 1.683l-14.661 9.35a.993.993 0 0 1-.536.16zM23.321 33.47a1 1 0 0 1-.539-1.843l13.68-8.73a1 1 0 1 1 1.076 1.686l-13.68 8.73a1 1 0 0 1-.537.157zM24.3 22.12a1 1 0 0 1-.539-1.843l12.7-8.1a1 1 0 0 1 1.076 1.686l-12.7 8.1a.993.993 0 0 1-.537.157z",
    fill: "#FFFFFF",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowers);
export default __webpack_public_path__ + "static/media/towers.b3f5b4c199b826e3d0b5777797d735b6.svg";
export { ForwardRef as ReactComponent };